module.exports = __webpack_public_path__ + "static/media/pos_order_printing_h.2d53e09a.jpg";